const paybillMap = {
  'ipesa': '618755',
  'kashway':'900068',
  'creditmoja': '540310',
  'tifislice': '770805'
}
export default paybillMap;
